import { Pagination } from "@mui/material";
import { Button } from "components/Button/Button";
import IconButton from "components/Button/IconButton";
import NotFound from "components/not-found/NotFound";
import Switch from "components/Switch/Switch";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { RemoveRedEye } from "@mui/icons-material";
import ModalBox from "components/modal/ModalBox";
import toast from "react-hot-toast";
import { getItemSalesCustomerList } from "services/itemsellsmanagement";

export default function ItemSellsList() {
  const navigate = useNavigate();
  const [record, setRecord] = useState([]);
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [activePage, setActivePage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [total, setTotal] = useState(0);
  const [items, setItems] = useState([]);
  const [statusModal, setStatusModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [selectedId, setSelectedId] = useState("");

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();

  // ************************************** Fetch Records **********************************************
  const fetchRecord = async () => {
    showLoader();
    try {
      const res = await getItemSalesCustomerList({
        page: activePage,
        search: search,
        limit: limit,
      });
      hideLoader();
      if (res.code === 200) {
        const { rows, count } = res.data;
        setRecord(rows || []);
        setTotal(count || 0);
        if (total % limit > 0 || total > limit) {
          setPageCount(Math.round(count / limit) + 1);
        } else {
          setPageCount(Math.round(count / limit) + 1);
        }
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
  };
  useEffect(() => {
    fetchRecord();
  }, [activePage, search]);

  return (
    <>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="search_wrap w60per">
                <div className="SearchBox w-100 " style={{ gap: "2px" }}>
                  <div className="div_wrap mx-1 w40per"></div>
                  <div className="div_wrap mx-1 w40per">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control"
                      name="search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                  <div>
                    <Button to={"add-customer"}>Add&nbsp;Customer</Button>
                  </div>
                </div>
              </div>
              <h4 className="Title">Item's Sales Management</h4>
            </div>
            {loader}
            <div className="TableList overflow-auto table-responsive">
              {loader}
              <Table bordered className="table">
                <thead>
                  <tr>
                    <th className="border-right">S.No</th>
                    <th className="border-right">Customer Name</th>
                    <th className="border-right">Customer Mobile</th>
                    <th className="border-right">Total Quantity</th>
                    <th className="border-right">Total Amount</th>
                    <th className="border-right">Payment Mode</th>
                    <th className="border-right text-center">Item's List</th>
                    <th className="text-center ">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {record && record.length > 0 ? (
                    record.map(
                      (
                        {
                          id,
                          customerName,
                          customerMobile,
                          paymentMode,
                          totalQuantity,
                          totalAmount,
                          addedon,
                          items,
                        },
                        i
                      ) => (
                        <tr key={i}>
                          <td className="w100px">
                            {++i + (activePage - 1) * limit}
                          </td>
                          <td>{customerName}</td>
                          <td>{customerMobile}</td>
                          <td>{totalQuantity}</td>
                          <td>{totalAmount}</td>
                          <td>{paymentMode}</td>
                          <td className="w100px">
                            <div className="d-flex justify-content-center">
                              <div className="inline-block my-auto">
                                <IconButton
                                  aria-label="view"
                                  className="px-2 py-0"
                                  onClick={() => {
                                    setViewModal(true);
                                    setItems(items || []);
                                  }}
                                >
                                  <RemoveRedEye sx={{ color: "#4971B2" }} />
                                </IconButton>
                              </div>
                            </div>
                          </td>
                          <td className="w100px">
                            <div className="d-flex justify-content-center">
                              <div className="inline-block my-auto">
                                <IconButton
                                  aria-label="update"
                                  className="px-2 py-0"
                                  onClick={() => {
                                    navigate(`update-customer/${id}`);
                                  }}
                                >
                                  <EditIcon sx={{ color: "#4971B2" }} />
                                </IconButton>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )
                    )
                  ) : (
                    <NotFound cols={12} />
                  )}
                </tbody>
              </Table>
            </div>
            {total > 10 ? (
              <div className="Pagination">
                <Pagination
                  siblingCount={2}
                  page={activePage}
                  count={pageCount}
                  onChange={(e, value) => {
                    setActivePage(value);
                  }}
                  variant="outlined"
                  shape="rounded"
                  showFirstButton
                  showLastButton
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>

      {/* ***********************************  View Description ****************************************** */}
      <ModalBox
        status={viewModal}
        onClose={() => setViewModal(false)}
        size={"md"}
        title={"Item List"}
        description={
          <>
            <div className="TableList overflow-auto table-responsive">
              <Table bordered className="table">
                <thead>
                  <tr>
                    <th className="border-right">S.No</th>
                    <th className="border-right">Item Name</th>
                    <th className="border-right">Item Quantity</th>
                    <th className="border-right">Item Price</th>
                  </tr>
                </thead>
                <tbody>
                  {items && items.length > 0 ? (
                    items.map(({quantity,product}, i) => (
                      <tr key={i}>
                        <td className="w100px">{++i}</td>
                        <td>{product.producttitle}</td>
                        <td>{quantity}</td>
                        <td>{quantity*product.sellingprice}</td>
                      </tr>
                    ))
                  ) : (
                    <NotFound cols={12} />
                  )}
                </tbody>
              </Table>
            </div>
          </>
        }
        customizedFooter={true}
        Close={true}
        custom={false}
      />
    </>
  );
}
